/** Segundos inteiros até `liberaEm` (0 quando já passou). */
export function segundosParaLiberar(liberaEm: string, agoraMs: number): number {
  return Math.max(0, Math.ceil((Date.parse(liberaEm) - agoraMs) / 1000))
}

/** "libera em 12 min 05 s" — o texto da contagem regressiva do bloqueio. */
export function textoLiberaEm(liberaEm: string, agoraMs: number): string {
  const total = segundosParaLiberar(liberaEm, agoraMs)
  if (total === 0) return 'liberando…'
  const h = Math.floor(total / 3600)
  const min = Math.floor((total % 3600) / 60)
  const s = String(total % 60).padStart(2, '0')
  if (h > 0) return `libera em ${h} h ${String(min).padStart(2, '0')} min ${s} s`
  if (min > 0) return `libera em ${min} min ${s} s`
  return `libera em ${total % 60} s`
}
